import type { OrganLookupCode } from '@repo/types';

/**
 * Figma lists the systems head down, so the list reads like the body beside it.
 * `organs.priority` cannot serve: science sets that by prominence — the gut leads
 * at 10, the lungs trail at 130 — and the map paints in that order.
 *
 * Two rows sit off strict top-to-bottom in the design: skin comes up beside the
 * other whole-body systems, and the liver splits the gut from the kidneys.
 * Post-MVP codes are listed as well, so the order is right the day their artwork
 * lands.
 */
const ORGAN_DISPLAY_ORDER: OrganLookupCode[] = [
  'brain',
  'oral',
  'endocrine',
  'immune',
  'skin',
  'lung',
  'heart',
  'gut',
  'liver',
  'metabolic',
  'muscle',
  'reproductive',
  'kidney',
];

/** An unknown code sorts last, where `indexOf`'s -1 would put it first. */
const rank = (lookupCode: OrganLookupCode) => {
  const index = ORGAN_DISPLAY_ORDER.indexOf(lookupCode);
  return index === -1 ? ORGAN_DISPLAY_ORDER.length : index;
};

export const byOrganDisplayOrder = (
  a: { lookup_code: OrganLookupCode },
  b: { lookup_code: OrganLookupCode },
) => rank(a.lookup_code) - rank(b.lookup_code);
